export function GuestPageBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden>
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-sky-50/90 to-indigo-100/70" />

      <div className="absolute -left-28 -top-28 h-[32rem] w-[32rem] rounded-full bg-primary/25 blur-[100px]" />
      <div className="absolute -right-20 top-[18%] h-80 w-80 rounded-full bg-indigo-400/20 blur-[90px]" />
      <div className="absolute bottom-[-6rem] left-[15%] h-[28rem] w-[36rem] rounded-full bg-sky-300/25 blur-[110px]" />
      <div className="absolute bottom-[20%] right-[10%] h-72 w-72 rounded-full bg-violet-400/15 blur-[85px]" />
      <div className="absolute left-1/2 top-[42%] h-56 w-[28rem] -translate-x-1/2 rounded-full bg-primary/10 blur-[80px]" />

      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, hsl(221 83% 53% / 0.07) 1px, transparent 0)',
          backgroundSize: '28px 28px',
        }}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-white/10 to-white/40" />
    </div>
  )
}
